module.exports = __webpack_public_path__ + "img/stop_btn.2215eed3.png";